import { Dispatch } from 'redux';
import CrudActionContainer from './CrudActionContainer';
import { StoreState } from '../store-interfaces';
import { getActionHookBuilder } from './action-hook-builder';
import { SendlaneListsResponse } from '../model/SendlaneModel';
import { sendlaneErrorHandler } from '../errorHandlers/sendlane-handler';
import SendlaneController from '../controllers/SendlaneController';

class SendlaneCRUDActions extends CrudActionContainer {
  retrieveLists: string;

  constructor() {
    super('SENDLANE');
    this.retrieveLists = this.makeActionKey('RETRIEVED_LISTS');
  }

  getLists(webhookId: number) {
    return async (dispatch: Dispatch<StoreState>) => {
      dispatch(this.busy(this.retrieveLists));
      try {
        const response: SendlaneListsResponse =
          await SendlaneController.getLists(webhookId);
        dispatch({
          type: this.retrieveLists,
          lists: response,
        });
        return response;
      } catch (error) {
        sendlaneErrorHandler(dispatch)(error); // Same error handler as Klaviyo, separate them if needed
      }
    };
  }
}

const sendlaneCRUDActions = new SendlaneCRUDActions();

export default sendlaneCRUDActions;

export const useSendlaneCRUDActions = getActionHookBuilder(
  sendlaneCRUDActions,
  ['getLists'],
);
